import { Injectable } from '@angular/core';
import { FormResponseSearchDto } from 'src/app/forms/shared/model/form-response-search.dto';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { FormResponseDto } from '../dto/form-response.dto';
import { FormSubmissionSearchResultDto } from '../dto/form-submission-search-result.dto';
import { LinkResponseDto } from '../dto/link-response.dto';
import { FormResponseSearchResultDto } from '../dto/form-response-search-result.dto';

@Injectable({
  providedIn: 'root',
})
export class FormResponseV2Service {
  constructor(private _apiService: ApiService) {}

  delete(uniqueId: string) {
    return this._apiService.delete(`Forms/V2/Response/${uniqueId}`);
  }

  search<T>(params: FormResponseSearchDto, ignoreCache?: boolean): Promise<PagedResultGeneric<FormResponseSearchResultDto>> {
    const cacheOptions = ignoreCache ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged('Forms/V2/Responses', params, cacheOptions);
  }

  createProfileFromResponse(uniqueId: string): Promise<void> {
    return this._apiService.post(`Forms/V2/Response/${uniqueId}/CreateProfile`, {});
  }

  linkProfile(selectedProfileId: number, responseToLink: string) {
    return this._apiService.post(`Forms/V2/Response/Link`, {
      ProfileId: selectedProfileId,
      ResponseUniqueId: responseToLink,
    } as LinkResponseDto);
  }

  formSubmissionsExport(params: FormResponseSearchDto) {
    return this._apiService.post('Forms/V2/Responses/export', params);
  }

  get(uniqueId: string): PromiseLike<FormResponseDto<string>> {
    return this._apiService.get(`Forms/V2/Response/${uniqueId}`);
  }
}
